import imageCompression from "browser-image-compression";

export const compressImage = async (file) => {
  try {
    if (file.type === "application/pdf") {
      return file;
    }

    if (!file.type.startsWith("image/")) {
      return file;
    }

    if (file.size <= 100 * 1024) {
      return file;
    }

    if (file.type === "image/webp" && file.size <= 100 * 1024) {
      return file;
    }

    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1280,
      useWebWorker: true,
      fileType: "image/webp",
      initialQuality: 0.7,
    };

    const compressed = await imageCompression(file, options);

    if (compressed.size >= file.size) {
      return file;
    }

    return new File(
      [compressed],
      file.name.replace(/\.[^/.]+$/, "") + ".webp",
      { type: "image/webp" }
    );

  } catch (error) {
    console.error("Compression failed:", error);
    return file;
  }
};